import React, { FC } from 'react';
import styled from 'styled-components';
import { Button, H2, Icon, ModalContent, Text } from 'components';
import { toRem } from 'design';
import theme from 'design/theme';
import { Layout } from '../styles';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    margin: ${toRem(theme.space.xs)} 0;
    text-align: center;
  }

  button {
    margin: ${toRem(theme.space.lg)} 0;
    width: 100%;
  }

  h2 {
    text-align: center;
  }
`;

const IconWrapper = styled.div`
  border-radius: 50%;
  height: ${toRem(88)};
  width: ${toRem(88)};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${theme.color.warning[25]};
  margin-bottom: ${toRem(theme.space.md)};

  svg {
    fill: ${theme.color.warning[50]};
    height: ${toRem(55)};
    width: ${toRem(55)};
  }
`;

interface IErrorProps {
  dataCy: string;
  onClose: () => void;
}

const Error: FC<IErrorProps> = ({ onClose, dataCy }) => (
  <Layout isActive onClose={onClose} data-cy={`${dataCy}-error`} maxWidth={540}>
    <ModalContent>
      <Wrapper>
        <IconWrapper>
          <Icon icon="Caution" />
        </IconWrapper>
        <H2 fontWeight="semibold">We're sorry, an error has occurred.</H2>
        <Text size="small">If this problem persists, contact Kickfin Support</Text>
        <Button appearance="white" label="Close" onClick={onClose} />
      </Wrapper>
    </ModalContent>
  </Layout>
);

export default Error;
